import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from 'pdfmake/build/vfs_fonts';
import useDate from "../day";
import figureFormatter from "@/services/utils/figureFormatter";
import { loadImageAsBase64 } from "@/services/utils/global";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
  SulaimanLipi: {
    normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
    bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
    italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
    bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
  }
};

const printMushak62 = () => {
  const { formatDate } = useDate();
  const { commaFormat } = figureFormatter();

  const exportToPdfMushak62 = async (companyInfo, headerData, stockLedgers) => {
    const imagePath = await loadImageAsBase64('/app-assets/images/gov_seal.png');
    const doc = {
      pageSize: "A4",
      pageOrientation: "landscape",
      pageMargins: [15, 15, 15, 25],
      defaultStyle: {
        font: "SulaimanLipi",
        fontSize: 6
      },
      content: getContent(companyInfo, headerData, stockLedgers, imagePath),
      info: {
        title: 'মূসক-৬.২'
      },
      styles: styles
    };
    pdfMake.createPdf(doc).open();
  }

  const getContent = (companyInfo, headerData, stockLedgers, imagePath) => {
    return [
      getHeaderBlock(imagePath),
      { text: 'প্রতিষ্ঠানের নাম: ' + getValue(companyInfo.name), style: 'center' },
      { text: 'ব্যবসা সনাক্তকরণ সংখ্যা: ' + getValue(companyInfo.vat_no), style: 'center' },
      { text: 'ঠিকানা: ' + getValue(companyInfo.address), style: 'center' },
      { text: 'বিক্রয় হিসাব পুস্তক', style: 'h2', margin: [0, 3, 0, 0] },
      { text: '(পণ্য বা সেবা প্রক্রিয়াকরণে সম্পৃক্ত এমন নিবন্ধিত বা তালিকাভুক্ত ব্যক্তির জন্য প্রযোজ্য)', style: 'small' },
      { text: '[ বিধি ৪০ এর উপ-বিধি (১) এর দফা (খ) এবং বিধি ৪১ এর দফা (ক) দ্রষ্টব্য ]', style: 'small', margin: [0, 0, 0, 2] },
      { text: 'পণ্য/সেবার বিক্রয়', style: 'small', margin: [0, 0, 0, 4] },
      {
        table: {
          headerRows: 3,
          widths: getWidths(),
          body: getTableBody(stockLedgers)
        },
        layout: {
          hLineWidth: () => 0.5,
          vLineWidth: () => 0.5,
          hLineColor: () => '#000',
          vLineColor: () => '#000',
          paddingLeft: () => 1,
          paddingRight: () => 1,
          paddingTop: () => 1,
          paddingBottom: () => 1
        }
      },
      getSpecialNote()
    ];
  }

  const getHeaderBlock = (imagePath) => {
    const seal = imagePath ? { image: imagePath, width: 50, height: 50 } : { width: 50, text: '' };
    return {
      margin: [0, 0, 0, 4],
      columns: [
        seal,
        {
          width: '*',
          stack: [
            { text: 'গণপ্রজাতন্ত্রী বাংলাদেশ সরকার', style: 'h1' },
            { text: 'জাতীয় রাজস্ব বোর্ড', style: 'h1', margin: [0, 3, 0, 0] }
          ]
        },
        {
          width: 60,
          margin: [0, 15, 0, 0],
          table: { widths: ['*'], body: [[{ text: 'মূসক-৬.২', alignment: 'center', fontSize: 8 }]] },
          layout: {
            hLineWidth: () => 1,
            vLineWidth: () => 1,
            hLineColor: () => '#000',
            vLineColor: () => '#000'
          }
        }
      ]
    };
  }

  const getWidths = () => {
    return [
      22, 28,
      20, 26,
      20, 26,
      20, 26,
      '*', '*', 32,
      26, 24,
      '*', 20, 26, 24, 22,
      20, 26,
      22
    ];
  }

  const getTableBody = (stockLedgers) => {
    return [
      getGroupHeaderRow(),
      getLeafHeaderRow(),
      getNumberRow(),
      getBlankRow(),
      ...getDataRows(stockLedgers)
    ];
  }

  const getGroupHeaderRow = () => {
    return [
      { text: 'ক্রমিক সংখ্যা', style: 'th', rowSpan: 2 },
      { text: 'তারিখ', style: 'th', rowSpan: 2 },
      { text: 'উৎপাদিত পণ্য/সেবার প্রারম্ভিক জের', style: 'th', colSpan: 2 }, {},
      { text: 'উৎপাদন', style: 'th', colSpan: 2 }, {},
      { text: 'মোট উৎপাদিত পণ্য/সেবা', style: 'th', colSpan: 2 }, {},
      { text: 'ক্রেতা/ সরবরাহগ্রহীতা', style: 'th', colSpan: 3 }, {}, {},
      { text: 'চালানপত্রের বিবরণ', style: 'th', colSpan: 2 }, {},
      { text: 'বিক্রিত/সরবরাহকৃত পণ্যের বিবরণ', style: 'th', colSpan: 5 }, {}, {}, {}, {},
      { text: 'পণ্যের প্রান্তিক জের', style: 'th', colSpan: 2 }, {},
      { text: 'মন্তব্য', style: 'th', rowSpan: 2 }
    ];
  }

  const getLeafHeaderRow = () => {
    return [
      {}, {},
      { text: 'পরিমাণ (একক)', style: 'th' },
      { text: 'মূল্য (সকল প্রকার কর ব্যতীত)', style: 'th' },
      { text: 'পরিমাণ (একক)', style: 'th' },
      { text: 'মূল্য (সকল প্রকার কর ব্যতীত)', style: 'th' },
      { text: 'পরিমাণ (একক)', style: 'th' },
      { text: 'মূল্য (সকল প্রকার কর ব্যতীত)', style: 'th' },
      { text: 'নাম', style: 'th' },
      { text: 'ঠিকানা', style: 'th' },
      { text: 'নিবন্ধন/ তালিকাভুক্তি/ জাতীয় পরিচয়পত্র নং', style: 'th' },
      { text: 'নম্বর', style: 'th' },
      { text: 'তারিখ', style: 'th' },
      { text: 'বিবরণ', style: 'th' },
      { text: 'পরিমাণ', style: 'th' },
      { text: 'করযোগ্য মূল্য', style: 'th' },
      { text: 'সম্পূরক শুল্ক (যদি থাকে)', style: 'th' },
      { text: 'মূসক', style: 'th' },
      { text: 'পরিমাণ (একক)', style: 'th' },
      { text: 'মূল্য (সকল প্রকার কর ব্যতীত)', style: 'th' },
      {}
    ];
  }

  const getNumberRow = () => {
    const nums = ['(১)', '(২)', '(৩)', '(৪)', '(৫)', '(৬)', '(৭)=(৩+৫)', '(৮)=(৪+৬)', '(৯)', '(১০)', '(১১)', '(১২)', '(১৩)', '(১৪)', '(১৫)', '(১৬)', '(১৭)', '(১৮)', '(১৯)=(৭-১১)', '(২০)=(৮-২৬)', '(২১)'];
    return nums.map(function (n) {
      return { text: n, style: 'th' };
    });
  }

  const getBlankRow = () => {
    return Array.from({ length: 21 }, () => ({ text: ' ', style: 'td' }));
  }

  const getDataRows = (stockLedgers) => {
    if (!stockLedgers || !stockLedgers.length) return [getBlankRow()];
    const sales = stockLedgers.filter(function (item) {
      return item.txn_type === 'invoice_journal';
    });
    const lastLedger = stockLedgers[stockLedgers.length - 1];
    if (!sales.length) return [getClosingAdjustmentRow(getOpeningState(stockLedgers), lastLedger)];
    const rows = sales.map((item, index) => mapRow(item, index));
    const lastShown = sales[sales.length - 1];
    if (getNumber(lastShown.balance_stock) === getNumber(lastLedger.balance_stock)
      && getNumber(lastShown.balance_value) === getNumber(lastLedger.balance_value)) return rows;
    rows.push(getClosingAdjustmentRow(lastShown, lastLedger));
    return rows;
  }

  const getOpeningState = (stockLedgers) => {
    const first = stockLedgers[0];
    return {
      balance_stock: getNumber(first.balance_stock) - getNumber(first.in_quantity) + getNumber(first.out_quantity),
      balance_value: getNumber(first.balance_value) - getNumber(first.in_amount) + getNumber(first.out_amount)
    };
  }

  const getClosingAdjustmentRow = (lastShown, lastLedger) => {
    return [
      { text: '', style: 'td' },
      { text: '', style: 'td' },
      { text: money(lastShown.balance_stock), style: 'tdRight' },
      { text: money(lastShown.balance_value), style: 'tdRight' },
      { text: '', style: 'tdRight' },
      { text: '', style: 'tdRight' },
      { text: '', style: 'tdRight' },
      { text: '', style: 'tdRight' },
      { text: '', style: 'tdLeft' },
      { text: '', style: 'tdLeft' },
      { text: '', style: 'tdLeft' },
      { text: '', style: 'td' },
      { text: '', style: 'td' },
      { text: 'অন্যান্য মজুদ সমন্বয়', style: 'tdLeft' },
      { text: '', style: 'tdRight' },
      { text: '', style: 'tdRight' },
      { text: '', style: 'tdRight' },
      { text: '', style: 'tdRight' },
      { text: money(lastLedger.balance_stock), style: 'tdRight' },
      { text: money(lastLedger.balance_value), style: 'tdRight' },
      { text: 'বিক্রয় ব্যতীত অন্যান্য লেনদেনের প্রভাব', style: 'tdLeft' }
    ];
  }

  const mapRow = (item, index) => {
    const txnDate = getRowDate(item.date);
    const vatAmount = getNumber(item.vat_amount);
    const openingQty = getNumber(item.balance_stock) - getNumber(item.in_quantity) + getNumber(item.out_quantity);
    const openingValue = getNumber(item.balance_value) - getNumber(item.in_amount) + getNumber(item.out_amount);
    const totalQty = openingQty + getNumber(item.in_quantity);
    const totalValue = openingValue + getNumber(item.in_amount);
    const outValueNet = getNumber(item.out_amount) - vatAmount;
    return [
      { text: convertToBanglaNumber(index + 1), style: 'td' },
      { text: txnDate, style: 'td' },
      { text: money(openingQty), style: 'tdRight' },
      { text: money(openingValue), style: 'tdRight' },
      { text: money(item.in_quantity), style: 'tdRight' },
      { text: money(item.in_amount), style: 'tdRight' },
      { text: money(totalQty), style: 'tdRight' },
      { text: money(totalValue), style: 'tdRight' },
      { text: getValue(item.party_name), style: 'tdLeft' },
      { text: getValue(item.party_address), style: 'tdLeft' },
      { text: getValue(item.party_bin_no), style: 'tdLeft' },
      { text: getValue(item.txn_number), style: 'td' },
      { text: txnDate, style: 'td' },
      { text: getItemLabel(item), style: 'tdLeft' },
      { text: money(item.out_quantity), style: 'tdRight' },
      { text: money(outValueNet), style: 'tdRight' },
      { text: '', style: 'tdRight' },
      { text: money(vatAmount), style: 'tdRight' },
      { text: money(item.balance_stock), style: 'tdRight' },
      { text: money(item.balance_value), style: 'tdRight' },
      { text: '', style: 'td' }
    ];
  }

  const getItemLabel = (item) => {
    const name = getValue(item.item_name);
    if (!item.description) return name;
    return name + ' - ' + item.description;
  }

  const getRowDate = (date) => {
    if (!date) return '';
    return formatDate(new Date(date)).split(' ')[0];
  }

  const getSpecialNote = () => {
    return {
      stack: [
        { text: 'বিশেষ দ্রষ্টব্যঃ', fontSize: 8 },
        { text: '* যেইক্ষেত্রে অনিবন্ধিত ব্যক্তির নিকট পণ্য বিক্রয় করা হইবে সেইক্ষেত্রে উক্ত ব্যক্তির পূর্ণাঙ্গ নাম, ঠিকানা ও জাতীয় পরিচয়পত্র নম্বর যথাযথভাবে সংশ্লিষ্ট কলামে [(৯), (১০) ও (১১)] আবশ্যিকভাবে উল্লেখ করিতে হইবে।', fontSize: 8 }
      ],
      margin: [0, 6, 0, 0]
    };
  }

  const getValue = (value) => {
    if (!value) return '';
    return value;
  }

  const getNumber = (value) => {
    if (!value) return 0;
    return parseFloat(value);
  }

  const money = (value) => {
    if (!value) return 0;
    return commaFormat(value);
  }

  const convertToBanglaNumber = (number) => {
    const banglaDigits = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];
    return number.toString().split('').map(d => banglaDigits[d] || d).join('');
  }

  const styles = {
    h1: { fontSize: 11, alignment: 'center' },
    h2: { fontSize: 9, alignment: 'center' },
    center: { fontSize: 8, alignment: 'center' },
    small: { fontSize: 8, alignment: 'center' },
    th: { fontSize: 6, alignment: 'center', lineHeight: 1.1 },
    td: { fontSize: 6, alignment: 'center' },
    tdRight: { fontSize: 6, alignment: 'right' },
    tdLeft: { fontSize: 6, alignment: 'left' }
  };

  return {
    exportToPdfMushak62
  }
}

export default printMushak62;
